import sanityImage from '@sanity/image-url';
import sanityClient from 'lib/sanity';

const imageBuilder = sanityImage(sanityClient);
const dprVariants = [0.5, 0.75, 1, 1.5, 2, 3, 4];

const buildSrc = (image, { width, height, format, quality }) => {
  let imgSrc = imageBuilder.image(image);

  if (width) {
    imgSrc = imgSrc.width(Math.round(width));
  }

  if (height) {
    imgSrc = imgSrc.height(Math.round(height));
  }

  if (format) {
    imgSrc = imgSrc.format(format);
  }

  if (quality) {
    imgSrc = imgSrc.quality(quality);
  }

  return imgSrc.fit('max').auto('format').url();
};

const buildSrcSet = (image, { srcSizes, aspect, format, quality }) => {
  const sizes = srcSizes.map((width) => {
    let imgSrc = buildSrc(image, {
      ...{ width },
      height: aspect && Math.round(width * aspect) / 100,
      ...{ format },
      ...{ quality },
    });

    if (format) {
      imgSrc = imgSrc.format(format);
    }

    return `${imgSrc} ${width}w`;
  });

  return sizes.join(',');
};

export { buildSrc, buildSrcSet, dprVariants };
